import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { IGenericResponse } from '../../shared/interfaces/examenes.interface';

@Injectable({
  providedIn: 'root'
})
export class EventosService {
  private readonly apiUrl = environment.baseURL + 'eventos';
  private readonly httpClient = inject(HttpClient);

  getHorariosDisponibles(fecha: string, idMedico: string, idCentroMedico: string): Observable<IGenericResponse<string[]>> {
    const params: HttpParams = new HttpParams()
      .set('idMedico', idMedico)
      .set('idCentroMedico', idCentroMedico);
    return this.httpClient.get<IGenericResponse<string[]>>(`${this.apiUrl}/disponibilidad/${fecha}`, { params });
  }
}
